namespace GeniuzPOS.InitialData {
    export enum CashierLevel {
        ChshierLevel1 = 1,
        ChshierLeve2 = 2,
        ChshierLeve3 = 3,
        ChshierLeve4 = 4,
        ChshierLeve5 = 5,
        ChshierLeve6 = 6,
        ChshierLeve7 = 7,
        ChshierLeve8 = 8,
        ChshierLeve9 = 9
    }
    Serenity.Decorators.registerEnumType(CashierLevel, 'GeniuzPOS.InitialData.CashierLevel');
}
